
export function ConditionalBox({condition, sx, children}) {
    return ( condition ? children : null)
}